<template>
  <div
    @mouseover="onHover"
    @mouseleave="onLeave"
  >
    <ToggleButton
      :key="componentKey"
      v-model="inputValue"
      :labels="{ checked: checkedLabel, unchecked: uncheckedLabel }"
      :width="width"
      :height="height"
      :color="color"
    />
  </div>
</template>
  
  <script>
  import { mapActions } from 'vuex'
  import { ToggleButton } from 'vue-js-toggle-button'
  
  export default {
    name: 'SimpleSliderConfiguration',
    components: {
		ToggleButton
	},
    props: {
      controller:{
        type:Object,
        required: true
      },
      checkedLabel:{
        type:String,
        required: true
      },
      uncheckedLabel:{
        type:String,
        required: true
      },
      width:{
        type:Number,
        required: true
      },
      height:{
        type:Number,
        required: true
      },
      color:{
        type:String,
        required: false,
        default:'#75C791'
      }
    },
    computed: { 
      inputValue: {
        set (value) {
          this.controller.setValue(value)
        },
        get () {
          return this.controller.value
        }
      },
     },
    data() {
      return {
        componentKey: 0,
      };
    },
     methods: { 
      ...mapActions(['setContextOnHover']),
      forceRerender() {
        this.componentKey += 1;
      },
      onHover() {
        if(this.controller.contextHelp!==null){
          this.setContextOnHover(this.controller.contextHelp)
        }
      },
      onLeave(){
        if(this.controller.contextHelp!==null){
          this.setContextOnHover(null)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .label-input{
    margin: 0;
  }
  </style>